import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useEffect, useRef, useState } from "react";
import { useStyles } from "./style";
import { JobDetail } from "pages/c-dad-user-data";
import { Refresh } from "@mui/icons-material";
import MultiSelectAutoCompleteWithButton, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple-with-button";
import { autoCompleteSelectOptionsFormat, checkAllMinMaxUpdated, defaultMinMaxValue, faultDataTriggerMinMax, getMaxValue, selectedListValues, trimToTwoDecimalPlaces, updateMinMaxValue } from "utility/helper";
import { listItemProp } from "utility/types";
import MinMaxModal from "./components";
import DefaultSignalDataModal from "./components/defaultListModal";
import { defaultSignalStatListData } from "utility/constants";
import { cDadFaultData } from "assets/DataFile/headerPageData";

dayjs.extend(utc);

const TableDataFault = (props: any) => {
  const style = useStyles();
  const { data, headValues } = props;
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: ' repeat(1, minmax(0, 1fr))',
      overflow: 'auto',
      whiteSpace: 'nowrap'
    }}>
      <table id="faultDataTable" className={style.tableContainer}>
        <tr >
          <th className={style.tableHeading}>CHANNEL</th>
          {headValues?.map((item: string) => {
            return (
              <td className={style.tableHeading}>{item}</td>
            )
          })}
        </tr>
        <tr>
          <th className={style.tableCell}>Out Of Range Count</th>
          {data?.map((item: any) => {
            return (
              <td className={style.tableCell}>{Math.round(item?.Count || 0)}</td>
            )
          })}
        </tr>
        <tr>
          <th className={style.tableCell} >Out Of Range Percentage %</th>
          {data?.map((item: any) => {
            return (
              <td className={style.tableCell}>{trimToTwoDecimalPlaces(Number(item?.CountPerc || 0))}%</td>
            )
          })}
        </tr>
        <tr>
          <th className={style.tableCell}>Min</th>
          {data?.map((item: any) => {
            return (
              <td className={style.tableCell}>{trimToTwoDecimalPlaces(Number(item?.min)) || 0}</td>
            )
          })}
        </tr>
        <tr>
          <th className={style.tableCell}>Max</th>
          {data?.map((item: any) => {
            return (
              <td className={style.tableCell}>{trimToTwoDecimalPlaces(Number(item?.max)) || 0}</td>
            )
          })}
        </tr>
      </table>
    </div>
  )
}

interface SignalDataStatsprops {
  jobDetails: JobDetail[];
  expanded?: string;
}

const SignalDataStatistics = (props: SignalDataStatsprops) => {
  const theme = useTheme();
  const { jobDetails, expanded } = props
  const [signalListData, setSingnalListData] = useState<string[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [defaultSignalDataModalOpen, setDefaultSignalDataModalOpen] = useState(false);
  const [faultFilter, setFaultFilter] = useState('wf');
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);
  const [minMaxValue, setMinMaxvalue] = useState<any>({});
  const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
  const [customMinMax, setCustomMinMax] = useState<any>();
  const [tableData, setTableData] = useState<any>(null);
  const [, setDeleteFilter] = useState<string>('withinrange')

  const refreshDataExtraction = async () => {
    console.log('refresh data extraction')
  }

  useEffect(() => {
    if (expanded === "panel3") refreshDataExtraction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded])

  const handleKeyUp = () => {
    if (minMaxValue && signalListData?.length === Object.entries(minMaxValue)?.length && !checkAllMinMaxUpdated(Object.entries(minMaxValue))) {
      setSubmitDisabled(false)
    }
    if (minMaxValue && signalListData?.length === Object.entries(minMaxValue)?.length && checkAllMinMaxUpdated(Object.entries(minMaxValue))) {
      setSubmitDisabled(true)
    }
  };

  const faultDatatriggerPayload = async (minMaxPayValue: any) => {
    for (const [key, values] of Object.entries(defaultSignalStatListData)) {
      if (!minMaxPayValue?.hasOwnProperty(key)) {
        minMaxPayValue[key] = values
      }
    }
    const updatedDataValue = await updateMinMaxValue(minMaxPayValue, {});
    setTableData(getMaxValue(Object.values(updatedDataValue)))
  }


  const handleSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setSingnalListData(
      value
    );
  }

  useEffect(() => {
    if (!modalOpen) {
      setMinMaxvalue({})
      setSubmitDisabled(true)
    }
  }, [modalOpen])

  const handleDoneClick = () => {
    let defaultMinMax: any = {};
    signalListData?.forEach((item: string) => {
      defaultMinMax[item] = {
        min: '',
        max: ''
      }
    })
    setMinMaxvalue(defaultMinMax);
    setModalOpen(true)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, type: string, row: string) => {
    const { value } = event.target;
    setMinMaxvalue((prevState: any) => ({
      ...prevState,
      [row]: {
        ...prevState[row],
        [type]: value
      }
    }));
  };

  const handleMinMaxData = async () => {
    const minMaxResp = faultDataTriggerMinMax(signalListData, customMinMax);
    console.log('min max', minMaxResp)
  }

  useEffect(() => {
    handleKeyUp()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minMaxValue])

  useEffect(() => {
    if (cDadFaultData) {
      const updatedDataValue = defaultMinMaxValue(defaultSignalStatListData, cDadFaultData?.data);
      setTableData(getMaxValue(Object.values(updatedDataValue)))
    }
  }, [])

  return (
    <>
      {expanded === 'panel3' ?
        <Box>
          <Box
            sx={{
              display: {
                md: "flex",
                sm: "flex",
                xs: "none",
              },
            }}
            alignItems={"center"}
          >
            <Box flex={1} display={'flex'} justifyContent={'space-between'}>
              <div>
                {jobDetails && jobDetails?.map((item: JobDetail) => (
                  <Typography key={item.id} fontWeight={"600"}>
                    <span>
                      {item.title}:{" "}
                    </span>
                    <span>
                      {item.value}
                    </span>
                  </Typography>
                ))}
              </div>
              <div>
                <Button
                  startIcon={<Refresh />}
                  onClick={refreshDataExtraction}
                  color="primary"
                  sx={{
                    borderRadius: 50,
                    px: 2,
                    backgroundColor: theme.palette.primary.contrastText,
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.main,
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                >
                  Refresh
                </Button>
                <Button
                  onClick={() => { setDefaultSignalDataModalOpen(true) }}
                  color="primary"
                  sx={{
                    borderRadius: 50,
                    px: 2,
                    backgroundColor: theme.palette.primary.contrastText,
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.main,
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                >
                  Default List
                </Button>
              </div>
            </Box>
          </Box>
          <Paper
            elevation={2}
            sx={{
              marginTop: "10px",
              padding: 1,
            }}
          >
            {tableData ? <TableDataFault key={'faulData'} faultFilter={faultFilter} data={tableData} headValues={Object.keys(cDadFaultData?.data)} /> : null}
            <div style={{ padding: '1%', display: 'flex', justifyContent: "space-between" }}>
              <div style={{ width: '65%' }}>
                <Typography ml={1} fontWeight={"bold"}>
                  ERRORS AND FAULTS: <span style={{ fontWeight: "normal" }}>Review errors/faults for problems. Decide if you want analysis with know fault OR without faults.</span>
                </Typography>
              </div>
              <div className='dataypeSelect'>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue="wf"
                >
                  <FormControlLabel value="wf" onClick={() => { setFaultFilter('wf'); }} control={<Radio />} label="With Faults" />
                  <FormControlLabel value="wof" onClick={() => { setFaultFilter('wof'); }} control={<Radio />} label="WithOut Faults" />
                </RadioGroup>
              </div>
            </div>
            <Divider />
            <div style={{ padding: '1%', display: 'flex', justifyContent: "space-between" }}>
              <div style={{ width: '55%' }}>
                <Typography ml={1} fontWeight={"bold"}>
                  OUT OF RANGE: <span style={{ fontWeight: "normal" }}>Confirm the existing Min and Max values. If OK no further action. If not Ok , adjust Min and Max values selecting Signal values in the dropdown.</span>
                </Typography>
              </div>
              <div style={{ width: '35%' }}>
                <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontWeight: 'bold' }}>Channel: </FormLabel>
                <FormControl style={{ width: '100%' }}
                >
                  <MultiSelectAutoCompleteWithButton
                    items={autoCompleteSelectOptionsFormat(Object.keys(cDadFaultData?.data))}
                    label="Select / Search Channels"
                    selectAllLabel="Select All"
                    onChange={(value: listItemProp[]) => {
                      // if (value?.length > 0) handleSignalSelection(value)
                      handleSignalSelection(value)
                    }}
                    ref={childRef}
                    onDone={handleDoneClick}
                  />
                </FormControl>

              </div>

            </div>
            <div>
              <Paper style={{ width: '45%', backgroundColor: theme.palette.primary.main }}>
                <Typography ml={1} fontWeight={"bold"} color={theme.palette.primary.contrastText}>
                  Removing values modifies the results of any future analysis and should only be done after understanding the vehicle interpretation of signals and downstream impact on analysis
                </Typography>
              </Paper>
            </div>
            {customMinMax && <div style={{ padding: '1%', display: 'flex', justifyContent: "space-between" }}>
              <div style={{ width: '65%' }}>
                <Typography ml={1} fontWeight={"bold"}>
                  DELETE RECORDS
                </Typography>
              </div>
              <div className='dataypeSelect'>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue="withinrange"
                >
                  <FormControlLabel value="withinrange" onClick={() => { setDeleteFilter('withinrange'); }} control={<Radio />} label="WithIn Range" />
                  <FormControlLabel value="outsiderange" onClick={() => { setDeleteFilter('outsiderange'); }} control={<Radio />} label="Out Of Range" />
                </RadioGroup>
              </div>
            </div>}
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-evenly"}
              alignItems={"center"}
              padding={'2%'}
            >
              <Button variant='contained' disabled={!customMinMax} style={{ width: '25%' }} onClick={() => { handleMinMaxData() }}>Delete Records</Button>
            </Box>
          </Paper>
          <MinMaxModal modalOpen={modalOpen} tableData={tableData} minMaxValue={minMaxValue} setModalOpen={setModalOpen} handleChange={handleChange} submitDisabled={submitDisabled} faultDataPayload={setCustomMinMax} faultDatatriggerPayload={faultDatatriggerPayload} signalListData={signalListData} />
          <DefaultSignalDataModal signalDataModalOpen={defaultSignalDataModalOpen} setDefaultSignalDataModalOpen={setDefaultSignalDataModalOpen} />
        </Box> : null}
    </>
  );
};

export default SignalDataStatistics;